import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-secondary-200/70 hover:border-primary-200 transition-all duration-300"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/90 text-primary-600">
            {article.categoryName}
          </span>
        </div>
      </div>
      <div className="p-5">
        <h3 className="text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span>{article.date}</span>
          <span>{article.readTime}</span>
        </div>
      </div>
    </Link>
  );
}